<template>
  <v-layout class="login" align-center justify-center>
    <v-flex xs12 sm8 md4>
      <v-card class="elevation-6">
        <v-toolbar dark :color="toolbarColor" class="darken-1" extended :height="64">
          <div class="login__container">
            <img src="@/assets/logo.png" class="login__img">
          </div>
        </v-toolbar>
        <v-card-title v-if="errorMsg" class="login__message">
          <strong>Error:</strong> <i>{{ errorMsg }}</i>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model.trim="userName"
              id="userName"
              name="userName"
              label="User Name"
              type="text"
              required
              @input="$v.userName.$touch()"
              :color="validateUserName"></v-text-field>
            <v-text-field
              v-model.trim="password"
              id="password"
              name="password"
              label="Password"
              type="password"
              hint="At least 8 characters"
              min="8"
              required
              @input="$v.password.$touch()"
              :color="validatePassword"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn outline small color="primary" to="/forgot-password">Forgot Password</v-btn>
          <v-btn outline small color="primary" to="/register">Register</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="$v.$invalid" :loading="isLoggingIn" @click="login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  data: () => {
    return {
      errorMsg: undefined,
      isLoggingIn: false,
      password: '',
      userName: ''
    }
  },
  computed: {
    toolbarColor () {
      return !this.$v.$invalid && !this.errorMsg ? 'primary' : 'grey'
    },
    validateUserName () {
      return !this.$v.userName.$error ? 'primary' : 'red'
    },
    validatePassword () {
      return !this.$v.password.$error ? 'primary' : 'red'
    },
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      defaultUserPath: 'user/defaultUserPath'
    })
  },
  mounted () {
    if (this.isLoggedIn) {
      this.$router.push(this.defaultUserPath)
    }
  },
  methods: {
    login () {
      if (this.$v.$invalid) {
        this.$v.userName.$touch()
        this.$v.password.$touch()
        return
      }

      this.errorMsg = undefined
      this.isLoggingIn = true
      this.$store.dispatch('user/login', { userName: this.userName, password: this.password }).catch(() => {
        this.isLoggingIn = false
        this.errorMsg = 'There was an error logging in. Please check your credentials and try again or reset your password.'
      })
    }
  },
  validations: {
    userName: {
      required,
      email,
      minLength: minLength(3)
    },
    password: {
      required,
      minLength: minLength(8)
    }
  }
}
</script>

<style lang="scss">
.login {
  &__container {
    height: 100%;
    position: relative;
    text-align: center;
    width: 100%;
  }

  &__img {
    height: 120px;
    margin-top: 5px;
    padding: 10px;
  }

  &__message {
    background-color: lighten(red, 45%);
    border: solid 1px lighten(red, 30%);
    border-top: 2px;
    color: red;
  }

  .input-group--error {
    // Important required because vuetify sets primary--text color as important
    color: red !important;
  }
}
</style>
